import { render, staticRenderFns } from "./ModalForAssignment.vue?vue&type=template&id=1bb54905&scoped=true"
import script from "./ModalForAssignment.vue?vue&type=script&lang=js"
export * from "./ModalForAssignment.vue?vue&type=script&lang=js"
import style0 from "./ModalForAssignment.scss?vue&type=style&index=0&id=1bb54905&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb54905",
  null
  
)

export default component.exports